import {
  apiDelete,
  apiGet,
  apiPut,
  type ApiResponse,
} from "./genesisApi/httpsMethods";
import type {
  DealAssignee,
  Notification,
  ReadByEntityBody,
  UnreadCountResponse,
} from "../types/dealTask";

export async function getUnreadCount(
  userId: number,
): Promise<ApiResponse<UnreadCountResponse>> {
  return apiGet<UnreadCountResponse>(
    `notifications/${userId}/unread-count`,
  );
}

export async function getNotifications(
  userId: number,
  unreadOnly?: boolean,
): Promise<ApiResponse<Notification[]>> {
  const queryParams = unreadOnly ? { unread_only: true } : undefined;
  return apiGet<Notification[]>(`notifications/${userId}`, queryParams);
}

export async function markNotificationRead(
  notificationId: number,
  userId: number,
): Promise<ApiResponse<Notification>> {
  return apiPut<Notification>(
    `notifications/${notificationId}/read`,
    0,
    { user_id: userId },
    true,
  );
}

export async function markAllNotificationsRead(
  userId: number,
): Promise<ApiResponse<{ message?: string }>> {
  return apiPut<{ message?: string }>(
    `notifications/${userId}/read-all`,
    0,
    {},
    true,
  );
}

export async function markNotificationsReadByEntity(
  userId: number,
  body: ReadByEntityBody,
): Promise<ApiResponse<{ message?: string }>> {
  return apiPut<{ message?: string }>(
    `notifications/${userId}/read-by-entity`,
    0,
    body,
    true,
  );
}

export async function getDealAssignees(): Promise<ApiResponse<DealAssignee[]>> {
  return apiGet<DealAssignee[]>("deal-assignees");
}

export async function deleteDealAssignee(
  dealId: number,
): Promise<ApiResponse<{ message?: string }>> {
  return apiDelete<{ message?: string }>("deal-assignees", dealId);
}
